(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cartRoot = document.getElementById('cart');
    if (!cartRoot) return;

    const changeUrl = `${cartRoot.dataset.cartChangeUrl}.js`;
    const currencyCode = cartRoot.dataset.currencyCode;

    cartRoot.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-action]');
      if (!button) return;

      const itemRow = button.closest('.cart__item');
      if (!itemRow) return;

      const lineIndex = itemRow.dataset.line;
      const qtyEl = itemRow.querySelector('.cart__qty-value');
      const currentQty = parseInt(qtyEl.dataset.qty, 10);
      const isInventoryManaged = itemRow.dataset.inventoryManaged === 'true';
      const maxQty = parseInt(itemRow.dataset.maxQty, 10);
      const action = button.dataset.action;

      let newQty = currentQty;

      if (action === 'increase') {
        if (isInventoryManaged && currentQty >= maxQty) return;
        newQty = currentQty + 1;
      } else if (action === 'decrease') {
        if (currentQty <= 1) return;
        newQty = currentQty - 1;
      } else if (action === 'remove') {
        newQty = 0;
      }

      if (newQty === currentQty) return;

      itemRow.classList.add('cart__item--updating');

      try {
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(lineIndex, 10),
            quantity: newQty,
          }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        const updatedCart = await response.json();

        if (updatedCart.item_count === 0) {
          window.location.reload();
          return;
        }

        if (newQty === 0) {
          itemRow.remove();
          reindexCartLines();
        } else {
          const updatedItem = updatedCart.items[parseInt(lineIndex, 10) - 1];
          if (updatedItem) updateItemRowUI(itemRow, updatedItem, maxQty, isInventoryManaged);
        }

        updateCartSummaryUI(updatedCart);
      } catch (error) {
        console.error(error);
      } finally {
        itemRow.classList.remove('cart__item--updating');
      }
    });

    function updateItemRowUI(row, item, maxQty, isInventoryManaged) {
      const qtyVal = row.querySelector('.cart__qty-value');
      const minusBtn = row.querySelector('[data-action="decrease"]');
      const plusBtn = row.querySelector('[data-action="increase"]');
      const priceVal = row.querySelector('[data-item-price]');

      qtyVal.textContent = item.quantity;
      qtyVal.dataset.qty = item.quantity;

      if (priceVal) {
        priceVal.textContent = formatMoney(item.final_line_price);
      }

      if (item.quantity <= 1) {
        minusBtn.classList.add('cart__qty-btn--disabled');
        minusBtn.setAttribute('disabled', 'disabled');
      } else {
        minusBtn.classList.remove('cart__qty-btn--disabled');
        minusBtn.removeAttribute('disabled');
      }

      if (isInventoryManaged && item.quantity >= maxQty) {
        plusBtn.classList.add('cart__qty-btn--disabled');
        plusBtn.setAttribute('disabled', 'disabled');
      } else {
        plusBtn.classList.remove('cart__qty-btn--disabled');
        plusBtn.removeAttribute('disabled');
        plusBtn.removeAttribute('title');
      }
    }

    function updateCartSummaryUI(cart) {
      document.querySelectorAll('[data-cart-subtotal], [data-cart-total]').forEach((el) => {
        el.textContent = formatMoney(cart.total_price);
      });
    }

    function reindexCartLines() {
      document.querySelectorAll('.cart__item').forEach((row, index) => {
        row.dataset.line = index + 1;
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.simple-form');
    if (!form) return;

    // Éléments du DOM
    const fileInput = document.getElementById('file-input');
    const dropZone = document.getElementById('drop-zone');
    const previewContainer = document.getElementById('preview-container');
    const dropZonePrompt = document.getElementById('drop-zone-prompt');
    const submitButton = form.querySelector('.form__submit');
    const submitText = submitButton ? submitButton.querySelector('span:not(.form__spinner)') : null;
    const submitSpinner = submitButton ? submitButton.querySelector('.form__spinner') : null;

    // API KEY : TODO @meraeky IMGBB

    // S'assurer que le spinner est masqué au chargement initial
    if (submitSpinner) {
      submitSpinner.hidden = true;
    }

    // Configuration des contraintes Fichiers
    const MAX_FILE_SIZE_MB = 5;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 5 Mo
    const MAX_IMAGE_DIMENSION = 2048; // Redimensionnement max (px)
    const COMPRESSION_QUALITY = 0.7; // Qualité JPEG (70%)

    // Gestionnaire global de fichiers
    const globalDataTransfer = new DataTransfer();
    let isProcessingImages = false;

    /* ==========================================================================
     1. GESTION DU DRAG & DROP ET DES FICHIERS
     ========================================================================== */

    if (dropZone && fileInput) {
      ['dragover', 'dragenter'].forEach((eventName) => {
        dropZone.addEventListener(eventName, (e) => {
          e.preventDefault();
          e.stopPropagation();
          dropZone.classList.add('drop-zone--over');
        });
      });

      ['dragleave', 'dragend'].forEach((eventName) => {
        dropZone.addEventListener(eventName, (e) => {
          e.preventDefault();
          e.stopPropagation();
          dropZone.classList.remove('drop-zone--over');
        });
      });

      dropZone.addEventListener('drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.remove('drop-zone--over');

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          processFiles(e.dataTransfer.files);
        }
      });

      fileInput.addEventListener('change', () => {
        if (fileInput.files && fileInput.files.length > 0) {
          processFiles(fileInput.files);
        }
      });
    }

    const MAX_ALLOWED_FILES = 7;
    async function processFiles(files) {
      const fileArray = Array.from(files);

      // Vérification du nombre total cumulé
      if (globalDataTransfer.files.length + fileArray.length > MAX_ALLOWED_FILES) {
        alert(`Vous ne pouvez pas envoyer plus de ${MAX_ALLOWED_FILES} images au total.`);
        return;
      }

      for (const file of fileArray) {
        if (!file.type.startsWith('image/')) continue;

        if (file.size > MAX_FILE_SIZE_BYTES) {
          alert(`Le fichier "${file.name}" dépasse la limite autorisée de ${MAX_FILE_SIZE_MB} Mo.`);
          continue;
        }

        try {
          const compressedFile = await compressImage(file, MAX_IMAGE_DIMENSION, COMPRESSION_QUALITY);
          globalDataTransfer.items.add(compressedFile);

          const reader = new FileReader();
          reader.readAsDataURL(compressedFile);
          reader.onload = () => {
            renderThumbnail(reader.result, compressedFile);
          };
        } catch (error) {
          console.error('Erreur de compression :', error);
        }
      }

      fileInput.files = globalDataTransfer.files;
      updatePromptVisibility();
    }

    /* ==========================================================================
     2. ALGORITHME DE COMPRESSION IMAGE (CANVAS)
     ========================================================================== */

    // function compressImage(file, maxDimension, quality) {
    //   return new Promise((resolve, reject) => {
    //     const img = new Image();
    //     const objectUrl = URL.createObjectURL(file);

    //     img.onload = () => {
    //       URL.revokeObjectURL(objectUrl);

    //       let { width, height } = img;

    //       if (width > maxDimension || height > maxDimension) {
    //         if (width > height) {
    //           height = Math.round((height * maxDimension) / width);
    //           width = maxDimension;
    //         } else {
    //           width = Math.round((width * maxDimension) / height);
    //           height = maxDimension;
    //         }
    //       }

    //       const canvas = document.createElement('canvas');
    //       canvas.width = width;
    //       canvas.height = height;

    //       const ctx = canvas.getContext('2d');
    //       ctx.drawImage(img, 0, 0, width, height);

    //       canvas.toBlob(
    //         (blob) => {
    //           if (!blob) {
    //             reject(new Error('Échec du traitement Canvas'));
    //             return;
    //           }
    //           const newFileName = file.name.replace(/\.[^/.]+$/, '') + '.jpg';
    //           const compressedFile = new File([blob], newFileName, {
    //             type: 'image/jpeg',
    //             lastModified: Date.now(),
    //           });
    //           resolve(compressedFile);
    //         },
    //         'image/jpeg',
    //         quality
    //       );
    //     };

    //     img.onerror = (err) => {
    //       URL.revokeObjectURL(objectUrl);
    //       reject(err);
    //     };

    //     img.src = objectUrl;
    //   });
    // }

    /* ==========================================================================
     3. RENDU DES MINIATURES ET SUPPRESSION
     ========================================================================== */

    // function renderThumbnail(dataUrl, fileRef) {
    //   const wrapper = document.createElement('div');
    //   wrapper.classList.add('preview-wrapper');

    //   const img = document.createElement('img');
    //   img.src = dataUrl;
    //   img.classList.add('preview-thumb');

    //   const removeBtn = document.createElement('button');
    //   removeBtn.type = 'button';
    //   removeBtn.classList.add('remove-btn');
    //   removeBtn.ariaLabel = 'Remove image';
    //   removeBtn.innerHTML = `
    //   <svg viewBox="0 0 24 24">
    //     <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" 
    //           stroke="currentColor" 
    //           stroke-width="2" 
    //           stroke-linecap="round" 
    //           stroke-linejoin="round"/>
    //   </svg>
    // `;

    //   removeBtn.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     removeFile(fileRef, wrapper);
    //   });

    //   wrapper.appendChild(img);
    //   wrapper.appendChild(removeBtn);
    //   previewContainer.appendChild(wrapper);
    // }

    // function removeFile(fileToRemove, wrapperElement) {
    //   const newDataTransfer = new DataTransfer();

    //   for (let i = 0; i < globalDataTransfer.files.length; i++) {
    //     const file = globalDataTransfer.files[i];
    //     if (file !== fileToRemove) {
    //       newDataTransfer.items.add(file);
    //     }
    //   }

    //   globalDataTransfer.items.clear();
    //   for (let i = 0; i < newDataTransfer.files.length; i++) {
    //     globalDataTransfer.items.add(newDataTransfer.files[i]);
    //   }

    //   fileInput.files = globalDataTransfer.files;
    //   wrapperElement.remove();
    //   updatePromptVisibility();
    // }

    function updatePromptVisibility() {
      if (!dropZonePrompt) return;
      dropZonePrompt.style.display = globalDataTransfer.files.length > 0 ? 'none' : 'block';
    }

    /* ==========================================================================
     4. VALIDATION ET SOUMISSION DU FORMULAIRE
     ========================================================================== */

    const inputsToValidate = form.querySelectorAll('input, select, textarea');
    inputsToValidate.forEach((input) => {
      input.addEventListener('input', () => {
        if (input.checkValidity()) {
          input.classList.remove('input--error');
        }
      });
    });

    form.addEventListener('submit', async (event) => {
      if (!form.checkValidity()) return;

      // Si des images sont présentes et pas encore traitées
      if (globalDataTransfer.files.length > 0 && !isProcessingImages) {
        event.preventDefault();
        setSubmitStateLoading();

        try {
          // Nettoyage des anciens champs cachés
          form.querySelectorAll('.dynamic-attachment').forEach((el) => el.remove());

          // Envoi de chaque image vers ImgBB en parallèle
          // const uploadPromises = Array.from(globalDataTransfer.files).map(async (file, index) => {
          //   const formData = new FormData();
          //   formData.append('image', file);

          //   const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
          //     method: 'POST',
          //     body: formData,
          //   });

          //   const result = await response.json();

          //   if (result.success) {
          //     // Création d'un champ caché contenant le lien CDN direct de l'image
          //     const hiddenInput = document.createElement('input');
          //     hiddenInput.type = 'hidden';
          //     hiddenInput.className = 'dynamic-attachment';
          //     hiddenInput.name = `contact[Lien_Photo_${index + 1}]`;
          //     hiddenInput.value = result.data.url; // URL hébergée sur CDN (ex: https://i.ibb.co/xxx/image.jpg)
          //     form.appendChild(hiddenInput);
          //   } else {
          //     throw new Error("Échec de l'upload sur ImgBB");
          //   }
          // });

          // Attendre que tous les uploads soient terminés
          // await Promise.all(uploadPromises);

          // Autoriser la soumission finale vers Shopify
          isProcessingImages = true;

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        } catch (error) {
          console.error("Erreur lors de l'upload vers le CDN :", error);
          alert("Impossible d'héberger les images. Veuillez réessayer.");

          // Réinitialisation du bouton en cas d'erreur
          if (submitButton) submitButton.disabled = false;
          if (submitText) submitText.textContent = 'Envoyer';
          if (submitSpinner) submitSpinner.hidden = true;
        }
      }
    });

    function setSubmitStateLoading() {
      if (!submitButton) return;
      submitButton.disabled = true;
      if (submitText) submitText.textContent = 'Transmission en cours...';
      if (submitSpinner) submitSpinner.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mobile-drawer-toggle')) {
    customElements.define('mobile-drawer-toggle', class MobileDrawerToggle extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.overlay = document.getElementById('MobileNavOverlay');
        
        if (this.button && this.overlay) {
          this.button.addEventListener('click', this.toggleMenu.bind(this));
        }
      }

      toggleMenu() {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', !isExpanded);
        this.button.setAttribute('aria-label', isExpanded ? 'Ouvrir le menu' : 'Fermer le menu');
        
        this.overlay.classList.toggle('is-active', !isExpanded);
        this.overlay.setAttribute('aria-hidden', isExpanded);
        
        // Verrouillage du scroll arrière-plan
        document.body.style.overflow = isExpanded ? '' : 'hidden';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
